import UseModal from 'hooks/use-modal';
import useWindowSize from 'hooks/use-windowSize';
import Head from 'next/head';
import ReactPlayer from 'react-player';

import LectureChangeLog from 'components/pages/lecture/lecturechangelog/LectureChangeLog';
import LectureMainButton from 'components/pages/lecture/lecturemainbutton/LectureMainButton';
import CourseMainButton from 'components/pages/course/coursemainbutton/CourseMainButton';
import WishlistButton from 'components/common/wishlistbutton/WishlistButton';

import Link from 'next/link';
import { Link as ScrollLink } from 'react-scroll';
import BackButton from '@core/components/backbutton/BackButton';
import Badge from '@core/components/badge/Badge';
import ContentPrice from 'components/common/contentprice/ContentPrice';
import Modal from '@core/components/Modal/Modal';
import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';
import ContentCategoryChip from '../contentcategorychip/ContentCategoryChip';
import CourseProgress from 'components/common/courseprogress/CourseProgress';
import FinancialAid from '@core/components/financialaid/FinancialAid';

import { Lacking } from 'constants/content-status';
import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import { Book1, PlayCircle, Signpost } from 'iconsax-react';
import UserIcon from 'assets/icons/user-icon-yellow.svg';
import MoneyIcon from 'assets/icons/money-icon-yellow.svg';
import BillIcon from 'assets/icons/bill-icon-yellow.svg';
import LanguageIcon from 'assets/icons/autobrightness-icon-yellow.svg';
import MobileIcon from 'assets/icons/mobile-icon-yellow.svg';
import CertificateIcon from 'assets/icons/teacher-icon-yellow.svg';
import VIPIcon from 'assets/icons/vip-card-icon.svg';
import ArrowRight from 'assets/icons/arrow-right.svg';
import MagicStarIcon from 'assets/icons/star-rating.svg';
import AddIcon from 'assets/icons/add.svg';

import classes from './ContentOverview.module.scss';





const ContentOverview = ({ data, contentType = 'course', refetchOverview }) => {
	const { desktopDevice } = useWindowSize();

	const {
		destroyModal: destroyChangeLog,
		show: visibleChangeLog,
		showModal: showChangeLog
	} = UseModal();

	const {
		destroyModal: destroyVideoModal,
		show: showVideoModal,
		showModal: handleShowVideoModal
	} = UseModal();

	return (
		<>
			<div
				className={`${contentType === 'course' ? classes['content-course-bg'] : classes['content-jq-bg']
					} py-5`}>
				<div className="container">
					<BackButton type={'bordered'} className={'d-none d-xl-flex mb-4'} />
					<div className={`${classes['content-overview-wrapper']}`}>
						<div className={`d-flex flex-column justify-content-between gap-3 order-1 order-xl-1`}>
							<div
								className={`${classes['content-overview-wrapper__details']} d-flex flex-column gap-2 gap-xl-3`}>
								<Badge status={data?.status} />
								<h1 className="d-flex align-items-center gap-2">
									{data.has_vip_access && <VIPIcon />} {data.title}
								</h1>
								<div
									className={`${classes['content-version-data']} d-flex d-xl-none flex-row align-items-center justify-content-start gap-1`}>
									{data?.version_string && (
										<>
											<p>Version {data?.version_string}</p>
											<span className={`${classes['seperator-dot']}`} />
										</>
									)}
									{!data.last_updated_date ? (
										<>{data?.release_date && <p>Released on {data?.release_date}</p>}</>
									) : (
										<p>Last update on {data?.last_updated_date}</p>
									)}

									{data?.show_changelog && (
										<>
											<span className={`${classes['seperator-dot']}`} />
											<button
												className={`${classes['changelog-button']}`}
												onClick={() => showChangeLog()}>
												Last Updates <ArrowRight />
											</button>
										</>
									)}
								</div>
								<p>{data.short_introduction}</p>
							</div>

							<div className="d-flex flex-column gap-1">
								{data?.status === Lacking && (
									<ContentPrice
										className="my-1"
										price={data?.price}
										payable_price={data?.payable_price}
										promotion_percentage={data?.promotion_percentage}
										is_free={data?.is_free}
										discounted_price={data?.discounted_price}
										currency={data?.currency}
									/>
								)}
								<CourseProgress status={data?.status} />
								{!data?.is_free && (
									<div className={classes['premium-badge']}>
										Included with <span>Pharmuni Premium</span>
									</div>
								)}
								<div
									className={`${classes['action-status-detail']} d-flex flex-wrap  my-3 my-md-0`}>
									{contentType === 'course' ? (
										<LectureMainButton
											lecture_id={data?.id}
											status={data?.status}
											price={data?.price}
											refetchOverview={refetchOverview}
											unlock_in={data?.unlock_in}
										/>
									) : (
										<CourseMainButton
											course_id={data?.id}
											status={data?.status}
											price={data?.price}
											refetchOverview={refetchOverview}
										/>
									)}
									{/* {contentType === 'job-qualification' && !desktopDevice && (
										<WishlistButton
											content_id={data?.id}
											status={data?.status}
											exist={data?.exist_in_wishlist}
											content={contentType}
											refetchOverview={refetchOverview}
										/>
									)}
									{contentType !== 'job-qualification' && (
										<WishlistButton
											content_id={data?.id}
											status={data?.status}
											exist={data?.exist_in_wishlist}
											content={contentType}
											refetchOverview={refetchOverview}
										/>
									)} */}
								</div>
								<ul
									className={`${classes['content-features']} d-flex d-xl-none flex-column gap-3 mt-1 py-3`}>
									<li>
										<LanguageIcon /> {data.languages.map((lng) => lng.name).join(',')}
									</li>
									{data.lecture_count && (
										<li>
											<Book1 color="#faa61a" /> {data.lecture_count} Courses
										</li>
									)}
									<li>
										<MobileIcon /> Available on app
									</li>
									<li>
										<Link href={'/pharmuni-certificate'} rel="noopener noreferrer" target="_blank" className='text-dark' >
											<CertificateIcon /> + Certificate
										</Link>
									</li>
								</ul>
								<div className='d-block d-xl-none '>
									<FinancialAid isBanner={false} />
								</div>
							</div>
						</div>
						<div className="d-flex flex-column gap-4 order-0 order-xl-1">

							<div className={`${classes['content-image-video']}`}>
								<Head>
									<meta property="og:image" content={data?.image} />
								</Head>
								<img src={data?.image} alt={data?.title} />
								{data?.preview_video && (
									<button onClick={handleShowVideoModal}>
										<PlayCircle size="60" color="#ffffff" />
									</button>
								)}
								{data.status === 'coming_soon' && (
									<div className={`${classes['action-status-detail-coming-soon-badge']}`}>
										Coming Soon
									</div>
								)}
								{data.is_new && (
									<div className={`${classes['new-badge']}`}>
										New
									</div>
								)}
							</div>
							<div
								className={`${classes['content-version-data']
									} d-none d-xl-flex flex-row align-items-center ${contentType === 'course' ? 'justify-content-start' : 'justify-content-end'
									} gap-1`}>
								{data?.version_string && (
									<>
										<p>Version {data?.version_string}</p>
										<span className={`${classes['seperator-dot']}`} />
									</>
								)}
								{!data.last_updated_date ? (
									<>{data?.release_date && <p>Released on {data?.release_date}</p>}</>
								) : (
									<p>Last update on {data?.last_updated_date}</p>
								)}
								{data?.show_changelog && (
									<>
										<span className={`${classes['seperator-dot']}`} />
										<button
											className={`${classes['changelog-button']}`}
											onClick={() => showChangeLog()}>
											Last Updates <ArrowRight />
										</button>
									</>
								)}
								{/* {contentType === 'job-qualification' && (
									<div
										className={`${data?.exist_in_wishlist
											? classes['wishlist-btn-jq-exist']
											: classes['wishlist-btn-jq-not-exist']
											}`}>
										<WishlistButton
											content_id={data?.id}
											status={data?.status}
											exist={data?.exist_in_wishlist}
											content={contentType}
											refetchOverview={refetchOverview}
										/>
									</div>
								)} */}
							</div>
							{/* <div
								className={`${classes['content-owner-rate']} d-none d-xl-flex flex-row align-items-center justify-content-end gap-2`}>
								{data.status !== 'coming_soon' && (
									<>
										<MagicStarIcon />
										<h5>{data?.rate_average}</h5>
										<p>{`(${data?.rate_count} Reviews)`}</p>
									</>
								)}
								<span>
									By{' '}
									{data?.belongs_to?.website ? (
										<Link rel="noopener noreferrer" target="_blank" href={data?.belongs_to?.website}>
											{data?.belongs_to?.name} <ArrowRight />
										</Link>
									) : (
										<Link href="#">
											{data?.belongs_to?.name} <ArrowRight />
										</Link>
									)}
								</span>
							</div> */}
						</div>
					</div>
					<div className={classes['course-details']}>
						{data?.proficiency && (
							<div>
								<span className={classes['detail-title']}>
									Proficiency:
								</span>
								<div>
									<ProficiencyBadge proficiency={data?.proficiency} />
								</div>
							</div>
						)}
						{data.status !== 'coming_soon' && (
							<div>
								<span className={classes['detail-title']}>
									Rating:
								</span>
								{data?.rate_count === 0 ? (
									<>
										Not yet rated
									</>
								) : (
									<div className='d-flex align-items-center gap-1'>
										<MagicStarIcon />
										<h5 className='m-0'>{data?.rate_average}</h5>
										<p className='m-0'>{`(${data?.rate_count} Reviews)`}</p>
									</div>
								)}

							</div>
						)}
						<div>
							<span className={classes['detail-title']}>
								Instructor:
							</span>
							<div className={classes['instructor']}>
								{data?.belongs_to?.website ? (
									<Link rel="noopener noreferrer" target="_blank" href={data?.belongs_to?.website}>
										{data?.belongs_to?.name} <ArrowRight />
									</Link>
								) : (
									<>
										{data?.belongs_to?.name}
									</>
								)}
							</div>
						</div>
						<div className='fw-bold'>
							<Link href={'/pharmuni-certificate'} rel="noopener noreferrer" target="_blank" underline="none" className='d-flex text-dark flex-row gap-1'>
								<AddIcon />
								Pharmuni certificate
							</Link>
						</div>
						{data?.career_paths_count > 0 && (
							<div className='d-flex gap-1 flex-row align-items-center fw-bold'>
								<ScrollLink
									offset={-78}
									delay={0}
									spy
									to='career-paths'
									className={classes['scroll-link']}
								>
									<div className={classes['career-path']}>
										<Signpost color='#18BBA8' size={24} variant='TwoTone' />
										{data?.career_paths_count === 1 ? `Included in ${data?.career_paths[0]?.name} path` : `Included in ${data?.career_paths_count} Career Paths`}
									</div>
								</ScrollLink>
							</div>
						)}
					</div>
				</div>
			</div >
			<Modal
				title={
					<div
						className={`${classes['changelog-header']} d-flex flex-column align-items-center justify-content-center`}>
						<h3>ChangeLog</h3>
						<h5>{data?.title}</h5>
					</div>
				}
				closeHandler={destroyChangeLog}
				show={visibleChangeLog}
				type={MOBILE_FULLSCREEN}>
				<div className={`${classes['changelog-wrapper']}`}>
					<LectureChangeLog id={data?.id} />
				</div>
			</Modal>
			<Modal closeHandler={destroyVideoModal} show={showVideoModal}>
				<div className={`${classes['video-player-wrapper']}`}>
					<ReactPlayer
						config={{ file: { attributes: { controlsList: 'nodownload' } } }}
						url={data?.preview_video}
						className="react-player"
						playing
						width="100%"
						height="100%"
						controls={true}
					/>
				</div>
			</Modal>
		</>
	);
};

export default ContentOverview;
